var map = {
	"./img-1.png": 9465,
	"./img-10.png": 11453,
	"./img-2.png": 95458,
	"./img-3.png": 59115,
	"./img-4.png": 67124,
	"./img-5.png": 4605,
	"./img-6.png": 20838,
	"./img-7.png": 5935,
	"./img-8.png": 87928,
	"./img-9.png": 60641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61662;